export var EEventType = /*#__PURE__*/function (EEventType) {
  EEventType["ViewChanged"] = "viewChanged";
  EEventType["SendFormSucceed"] = "sendFormSucceed";
  EEventType["SendFormFailed"] = "sendFormFailed";
  EEventType["FaqLinkClicked"] = "faqLinkClicked";
  EEventType["HelpCenterLinkClicked"] = "helpCenterLinkClicked";
  EEventType["LinkOwnerClick"] = "linkOwnerClick";
  EEventType["FormLayoutModalClosed"] = "formLayoutModalClosed";
  EEventType["FormLayoutModalOpened"] = "formLayoutModalOpened";
  return EEventType;
}({});